import React from 'react';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {TagSmall} from '@wix/wix-ui-icons-common';
import {classes} from './ItemDiscounts.st.css';
import {LineItemDiscountModel} from '../../../../../domain/models/checkout/LineItems/LineItemDiscount.model';

export enum ItemDiscountsDataHook {
  Root = 'ItemDiscountsDataHook.Root',
  DiscountName = 'ItemDiscountsDataHook.DiscountName',
  DiscountIcon = 'ItemDiscountsDataHook.DiscountIcon',
}

export const ItemDiscounts = ({discounts}: {discounts: LineItemDiscountModel[]}) => {
  return (
    <div data-hook={ItemDiscountsDataHook.Root} className={classes.root}>
      {discounts?.map(({name}, index: number) => (
        <div key={`${name}-${index}`} className={classes.discountTag}>
          <TagSmall className={classes.discountIcon} data-hook={ItemDiscountsDataHook.DiscountIcon} />
          <Text data-hook={ItemDiscountsDataHook.DiscountName} className={classes.discountNameText}>
            {name}
          </Text>
        </div>
      ))}
    </div>
  );
};
